<template>
  <article :class="{ open: open }">
    <div class="row res-row h-100">
      <Bookmark
        v-if="showSavedIcon"
        :info="info"
        @refetch="() => $emit('refetchList')"
      ></Bookmark>
      <div class="col-6">
        <div class="sub-text">
          <div class="job-info-item">
            <p class="list-job-text">
              <img
                src="@/assets/images/icons/person.svg"
                alt=""
                width="18"
                height="15"
              />
              Name
            </p>
            <p class="list-job-text fw-600">
              {{ info.basicInfo ? info.basicInfo.name : "N/A" }}
            </p>
          </div>
          <div class="job-info-item">
            <p class="list-job-text">
              <img
                src="@/assets/images/icons/location.svg"
                alt=""
                width="18"
                height="15"
              />
              City
            </p>
            <p class="list-job-text fw-600">
              {{
                userLocation
                  ? userLocation
                  : info.workLocation
                  ? info.workLocation.city
                  : info.location
                  ? info.location.city
                  : info.workLocality
                  ? info.workLocality.city
                  : "N/A"
              }}
            </p>
          </div>
          <div class="job-info-item">
            <p class="list-job-text">
              <img src="@/assets/images/icons/rupee.png" alt="" width="17" />
              Salary
            </p>
            <p class="list-job-text fw-600">
              {{ info.currentSalary || "N/A" }} /-month
            </p>
          </div>
          <div class="job-info-item">
            <p class="list-job-text">
              <img
                src="@/assets/images/icons/briefcase.svg"
                alt=""
                width="15"
              />
              Key Skills
            </p>
            <div class="list-job-text fw-600">
              {{
                info?.skills?.length
                  ? info?.skills
                      .slice(0, 3)
                      .map((d) => d.name)
                      .join(", ") +
                    this.getSubPro(info) +
                    (info?.skills?.length > 3 ? "..." : "")
                  : info?.subProfile
                  ? info?.subProfile?.name
                  : "N/A"
              }}
            </div>
            <!-- <p class="list-job-text fw-600">
                {{ info.skills.length ? info.skills[0].name : "" }} {{ info.skills.length > 1 ? "..." : "" }}
            </p> -->
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="sub-text">
          <div class="job-info-item">
            <p class="list-job-text">
              <img
                src="@/assets/images/icons/profile.svg"
                alt=""
                width="18"
                height="18"
              />
              Profile
            </p>
            <p class="list-job-text fw-600">
              {{
                // userSkills
                //   ? userSkills
                //   : info?.profile
                //   ? info?.profile?.name
                userProfileSkill
              }}
            </p>
          </div>
          <!-- <div class="job-info-item">
                        <p class="list-job-text"><img src="@/assets/images/icons/locality.svg" alt="" width="18px"
                                height="15px" /> Locality</p>
                        <p class="list-job-text fw-600">{{ info.workLocality ? info.workLocality.location : "N/A" }}</p>
                    </div> -->
          <div class="job-info-item">
            <p class="list-job-text">
              <img
                src="@/assets/images/icons/briefcase.svg"
                alt=""
                width="15"
              />
              Experience
            </p>
            <p class="list-job-text fw-600">
              {{
                JSON.stringify(info?.experience)
                  ? `${info?.experience} Years`
                  : "N/A"
              }}
            </p>
          </div>
          <div class="tag red mt-4">
            {{
              dateTitle ? dateTitle : info.updatedAt ? "Last update" : "Applied"
            }}
            :
            {{
              dateKey
                ? formatDate(info[dateKey])
                : info.updatedAt
                ? formatDate(info.updatedAt)
                : formatDate(info.appliedOn)
            }}
          </div>
        </div>
      </div>
      <div
        style="width: 100%; border-top: 1px dashed #4e4d4d"
        class="mt-1 mb-1"
      ></div>
      <div v-if="open" class="col-6 mt-2">
        <div class="sub-text">
          <div class="job-info-item">
            <p class="list-job-text">
              <img
                src="@/assets/images/icons/profile.svg"
                alt=""
                width="18px"
                height="18px"
              />
              Industry
            </p>
            <p class="list-job-text fw-600">
              {{
                Array.isArray(openCard[info._id].industry) &&
                !!openCard[info._id].industry[0]
                  ? openCard[info._id].industry[0].name
                  : "N/A"
              }}
            </p>
          </div>
          <div class="job-info-item">
            <p class="list-job-text">
              <img
                src="@/assets/images/icons/location.svg"
                alt=""
                width="18px"
                height="18px"
              />
              Home Location
            </p>
            <p class="list-job-text fw-600">
              {{
                openCard[info._id].geo_with_lat_lon
                  ? openCard[info._id].geo_with_lat_lon.city ||
                    openCard[info._id].geo_with_lat_lon.geo_point
                  : openCard[info._id].location
                  ? openCard[info._id].location.city
                  : "N/A111"
              }}
            </p>
          </div>
          <div class="job-info-item">
            <p class="list-job-text">
              <img
                src="@/assets/images/icons/age.svg"
                alt=""
                width="18px"
                height="18px"
              />
              Age
            </p>
            <p class="list-job-text fw-600">
              {{ info.basicInfo.age || "N/A" }} Years
            </p>
          </div>
        </div>
      </div>
      <div v-if="open" class="col-6 mt-2">
        <div class="sub-text">
          <div class="job-info-item">
            <p class="list-job-text">
              <img
                src="@/assets/images/icons/education.svg"
                alt=""
                width="18px"
                height="18px"
              />
              Education
            </p>
            <p class="list-job-text fw-600">
              {{
                openCard[info._id].qualification
                  ? openCard[info._id].qualification.name
                  : "N/A"
              }}
            </p>
          </div>
          <div class="job-info-item">
            <p class="list-job-text">
              <img
                src="@/assets/images/icons/gender.svg"
                alt=""
                width="18px"
                height="18px"
              />
              Gender
            </p>
            <p class="list-job-text fw-600">
              {{
                openCard[info._id].basicInfo
                  ? openCard[info._id].basicInfo.gender === 2
                    ? "Female"
                    : "Male"
                  : "N/A"
              }}
            </p>
          </div>
          <!-- <div class="job-info-item">
            <p class="list-job-text">
              <img
                src="@/assets/images/icons/locality.svg"
                alt=""
                width="18px"
                height="15px"
              />
              Locality
            </p>
            <p class="list-job-text fw-600">
              {{ info.workLocality ? info.workLocality.location : "N/A" }}
            </p>
          </div> -->
          <!-- <div class="job-info-item">
            <p class="list-job-text"><img src="@/assets/images/icons/mail.svg" alt="" width="18px" height="18px" /> Email</p>
            <p class="list-job-text fw-600">{{ openCard[info._id].user.email || "N/A" }}</p>
            </div> -->
        </div>
      </div>
      <div class="col-sm-12 footer" style="display: flex; align-self: self-end">
        <button
          :disabled="viewLoading"
          @click="$emit('view', info._id, info)"
          class="ghost__btn blue"
        >
          <div v-if="viewLoading" class="spin"></div>
          <span v-else>
            <i class="fa fa-eye"></i>
            {{
              viewed
                ? "Viewed"
                : openCard[info._id]
                ? viewLoading
                  ? "Loading..."
                  : "Hide"
                : "View"
            }}
          </span>
        </button>
        <button
          :disabled="mobileLoading"
          @click="$emit('mobile', info._id, info)"
          class="ghost__btn green"
          style="margin: auto 3px"
        >
          <div
            v-if="showMobileNotification"
            style="right: 0px"
            class="notification"
          >
            To unlock the contact number of
            {{ info.basicInfo ? info.basicInfo.name : "User" }} buy our plan
            from view button
          </div>
          <div v-if="mobileLoading" class="spin"></div>
          <span v-else>
            <i class="fa fa-phone fs-sm"></i>
            {{ showMobile[info._id] ? showMobile[info._id] : "Mobile Number" }}
          </span>
        </button>
        <button
          :disabled="callbackLoading"
          @click="$emit('callback', info._id, info)"
          class="ghost__btn red"
        >
          <div
            v-if="showCallbackNotification"
            style="right: 0px"
            class="notification"
          >
            To send the sms to
            {{ info.basicInfo ? info.basicInfo.name : "User" }} buy our plan
            from view button
          </div>
          <div v-if="callbackLoading" class="spin"></div>
          <span v-else>
            {{ showCallback[info._id] ? "Sent" : "Get call back" }}
          </span>
        </button>
        <button
          :disabled="whatsappLoading"
          class="ghost__btn green small ml-1"
          @click="$emit('whatsapp', info._id, info)"
        >
          <div
            v-if="showWhatsappNotification"
            style="right: 0px"
            class="notification"
          >
            To send the whatsapp to
            {{ info.basicInfo ? info.basicInfo.name : "User" }} buy our plan
            from view button
          </div>
          <div v-if="whatsappLoading" class="spin"></div>
          <img
            v-else
            src="@/assets/images/icons/whatsapp.svg"
            alt=""
            height="22"
          />
        </button>
      </div>
    </div>
    <div
      @click="$emit('hideNotify')"
      v-if="showBackdropNotification"
      class="backdrop"
    ></div>
  </article>
</template>

<script>
import moment from "moment";
import Bookmark from "@/components/common/bookmark.vue";
export default {
  name: "ToggleCard",
  components: {
    Bookmark,
  },
  emits: [
    "callback",
    "view",
    "refetchList",
    "mobile",
    "whatsapp",
    "hideNotify",
  ],
  props: [
    "showSavedIcon",
    "info",
    "openCard",
    "viewed",
    "showMobile",
    "showCallback",
    "showWhatsapp",
    "dateTitle",
    "dateKey",
    "notify",
    "userSkills",
    "userLocation",
  ],
  computed: {
    viewLoading() {
      return this.openCard[this.info?._id] === "load";
    },
    mobileLoading() {
      return this.showMobile[this.info?._id] === "load";
    },
    callbackLoading() {
      return this.showCallback[this.info?._id] === "load";
    },
    whatsappLoading() {
      return this.showWhatsapp[this.info?._id] === "load";
    },
    showBackdropNotification() {
      return (
        !!this.notify &&
        Object.keys(this.notify)?.length &&
        !!this.notify[this.info._id]
      );
    },
    showMobileNotification() {
      return Boolean(
        this.showBackdropNotification && this.notify[this.info._id] === 1
      );
    },
    showCallbackNotification() {
      return Boolean(
        this.showBackdropNotification && this.notify[this.info._id] === 2
      );
    },
    showWhatsappNotification() {
      return Boolean(
        this.showBackdropNotification && this.notify[this.info._id] === 3
      );
    },
    open() {
      return (
        !!this.openCard[this.info?._id] &&
        this.openCard[this.info?._id] !== "load"
      );
    },
    userProfileSkill() {
      if (
        this.userSkills?.toLowerCase() ===
          this.info?.profile?.name?.toLowerCase() ||
        this.info?.skills?.find(
          (skill) => skill.name.toLowerCase() === this.userSkills?.toLowerCase()
        )
      ) {
        return this.userSkills;
      } else {
        return this.info?.profile?.name ?? this.userSkills ?? "NA";
      }
    },
  },
  watch: {
    openCard() {},
  },
  methods: {
    getSubPro(info) {
      if (info.subProfile) {
        if (
          info.skills.filter((e) => e.name === info.subProfile.name).length == 0
        ) {
          return `, ${info.subProfile.name}`;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    formatDate(date) {
      return moment(new Date(date)).format("D/MM/YY");
    },
  },
};
</script>

<style scoped>
.backdrop {
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.516);
  position: fixed;
  z-index: 9;
  top: 0px;
  left: 0px;
}

.notification {
  position: absolute;
  top: -80px;
  background: #ffeeee;
  border: 1px solid #ff4a4a;
  padding: 10px;
  width: 210px;
  box-sizing: border-box;
  white-space: normal;
  right: 0;
  max-width: 164px;
  line-height: 1.3;
  border-radius: 6px;
  color: #0a0a0a;
  font-size: 12px;
  z-index: 999999;
}

/* .infoIcon:hover + .notification {
    opacity: 1;
    display: block;
} */
.notification:after {
  content: "";
  position: absolute;
  bottom: -7px;
  width: 12px;
  height: 12px;
  right: 13px;
  border-bottom: 1px solid #ff4a4a;
  border-right: 1px solid #ff4a4a;
  transform: rotate(45deg);
  background: #ffeeee;
  z-index: 0;
}

.spin {
  border: 3px solid #dedede !important;
  border-radius: 50% !important;
  border-top: 3px solid white !important;
  width: 20px !important;
  height: 20px !important;
  margin: 0 auto !important;
  -webkit-animation: spin 1s linear infinite !important;
  /* Safari */
  animation: spin 1s linear infinite !important;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg) !important;
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
